// client/src/context/SocketContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "./AuthContext";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { authUser } = useAuth();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!authUser?.user?._id) return;

    const s = io("https://api.smsorbit.in", {
      transports: ["websocket"],
    });

    s.emit("join", authUser.user._id);
    setSocket(s);

    return () => s.disconnect();
  }, [authUser]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
